// extracted by mini-css-extract-plugin
export var content = "_o3-1";
export var fullScreen = "_o3-0";